import { render, staticRenderFns } from "./BlockEditorReference.vue?vue&type=template&id=0ed8a7e9&"
import script from "./BlockEditorReference.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorReference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports